import { useState, useCallback, useMemo } from 'react'

// Remove acentos e baixa pra lowercase pra comparações tolerantes.
// Combining marks ficam no range U+0300..U+036F após NFD.
function norm(s) {
  return (s || '').toString().toLowerCase()
    .normalize('NFD').replace(/[̀-ͯ]/g, '')
}

export const FILTROS_VAZIOS = {
  busca:       '',
  status:      [],
  origem:      [],   // 'local' | 'bling'
  prazoInicio: '',
  prazoFim:    '',
  valorMin:    '',
  valorMax:    '',
  vendedora:   [],
  cidade:      [],
  tags:        [],
  confirmacao: [],
  horario:     [],
}

export function usePedidosFiltros() {
  const [filtros, setFiltros] = useState(FILTROS_VAZIOS)

  const totalAtivos = useMemo(() => (
    (filtros.busca ? 1 : 0) +
    filtros.status.length +
    filtros.origem.length +
    filtros.vendedora.length +
    filtros.cidade.length +
    filtros.tags.length +
    filtros.confirmacao.length +
    filtros.horario.length +
    ((filtros.prazoInicio || filtros.prazoFim) ? 1 : 0) +
    ((filtros.valorMin    || filtros.valorMax) ? 1 : 0)
  ), [filtros])

  const limpar  = useCallback(() => setFiltros(FILTROS_VAZIOS), [])

  const toggle  = useCallback((key, val) => setFiltros(prev => ({
    ...prev,
    [key]: prev[key].includes(val) ? prev[key].filter(v => v !== val) : [...prev[key], val],
  })), [])

  const set     = useCallback((key, val) => setFiltros(prev => ({ ...prev, [key]: val })), [])

  const filtrar = useCallback((pedidos) => pedidos.filter(p => {
    if (filtros.busca) {
      // Busca robusta: sem acentos, case-insensitive, AND entre múltiplas palavras.
      // "fatima freitas" acha "Maria de Fátima de Azevedo Freitas Smith".
      const termos = norm(filtros.busca).split(/\s+/).filter(Boolean)
      const corpus = norm([
        p.numero, p.cliente?.nome, p.cliente?.contato, p.cliente?.cidade,
        p.cliente?.bairro, p.cliente?.endereco, p.resumo,
        p.cliente?.documento, p.vendedora,
      ].filter(Boolean).join(' | '))
      // Telefone digitado sem máscara também acha
      const corpusDigitos = (p.cliente?.contato || '').replace(/\D/g, '')
      const termoDigitos  = filtros.busca.replace(/\D/g, '')
      if (!termos.every(t => corpus.includes(t)) &&
          !(termoDigitos && corpusDigitos.includes(termoDigitos))) return false
    }
    if (filtros.status.length    && !filtros.status.includes(p.status))                            return false
    if (filtros.origem.length    && !filtros.origem.includes(p.origem === 'bling' ? 'bling' : 'local')) return false
    if (filtros.prazoInicio      && (!p.prazo || p.prazo < filtros.prazoInicio))                   return false
    if (filtros.prazoFim         && (!p.prazo || p.prazo > filtros.prazoFim))                      return false
    if (filtros.valorMin         && (p.valorTotal || 0) < Number(String(filtros.valorMin).replace(',', '.'))) return false
    if (filtros.valorMax         && (p.valorTotal || 0) > Number(String(filtros.valorMax).replace(',', '.'))) return false
    if (filtros.vendedora.length && !filtros.vendedora.includes(p.vendedora || ''))                return false
    if (filtros.cidade.length    && !filtros.cidade.includes(p.cliente?.cidade || ''))             return false
    if (filtros.tags.length      && !filtros.tags.some(t => (p.tags || []).includes(t)))           return false
    if (filtros.confirmacao.length && !filtros.confirmacao.includes(p.confirmacaoEntrega || ''))   return false
    if (filtros.horario.length   && !filtros.horario.includes(p.horarioEntrega || ''))             return false
    return true
  }), [filtros])

  return { filtros, totalAtivos, limpar, toggle, set, filtrar }
}
